import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordMatching(controlName: string, matchingControlName: string): ValidatorFn {
  return function (controls: AbstractControl): ValidationErrors | null {
    if (controls) {
      try {
        const newPassword = controls.get(controlName)!.value;
        const confirmPassword = controls.get(matchingControlName)!.value;
        if (
          controls.get(matchingControlName)!.errors &&
          !controls.get(matchingControlName)!.errors?.['confirmedValidator']
        ) {
          return null;
        }
        if (newPassword !== confirmPassword) {
          controls.get(matchingControlName)?.setErrors({ confirmedValidator: true });
          return { mismatchedPassword: true };
        } else {
          controls.get(matchingControlName)?.setErrors(null);
        }
      } catch (ex) {
        console.log(ex);
      }
    }
    return null;
  };
}

export function NoWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  if ((control.value as string)?.trim().length == 0) {
    return { whitespace: true };
  }
  return null;
}

export function NoWhitespaceValidator1(control: AbstractControl): ValidationErrors | null {
  if (control.value && control.value.indexOf(' ') !== -1) {
    return { whitespace: true };
  }
  return null;
}

export function atleastOneRolePermission(control: AbstractControl): ValidationErrors | null {
  if ((control.value as Array<any>).every((x: any) => !x.permissionIds))
    return { atleastOneRolePermission: true };
  return null;
}

export function uniqueAndExistingAgentsValidator(existingAgents: string[]): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const records: any = (formArray as FormGroup).controls['agents'];
    records.controls.forEach((control: any, index: number) => {
      const email = control.value.email;
      const isDuplicate = records.controls.some(
        (control: any, i: number) =>
          i !== index && control.value.email && control.value.email === email,
      );
      if (isDuplicate) {
        control.setErrors({ duplicateEmail: true });
      } else {
        control.setErrors(null);
        if (existingAgents.find((x: any) => x.email?.toLowerCase() === email?.toLowerCase())) {
          control.setErrors({ existingEmail: true });
        } else {
          control.setErrors(null);
        }
      }
    });
    return null;
  };
}

export function uniqueAndExistingEmailValidator(): ValidatorFn {
  return (formArray: AbstractControl): ValidationErrors | null => {
    const records: any = (formArray as FormGroup).controls['user'];
    records.controls.forEach((control: any, index: number) => {
      const email = control.value.email;
      const isDuplicate = records.controls.some(
        (control: any, i: number) =>
          i !== index && control.value.email && control.value.email === email,
      );
      if (isDuplicate) {
        control.setErrors({ duplicateEmailId: true });
      } else {
        control.setErrors(null);
      }
    });
    return null;
  };
}

export const atLeastOneRequired: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const labelIds = control.get('labelIds')?.value;
  const categoryId = control.get('categoryId')?.value;

  if (!labelIds && !categoryId) {
    return { atLeastOneRequired: true }; // Custom validation error
  }

  return null; // No error
};
